/* eslint max-len: "off" */
import agriculturalLand from '@propertypal/shared/src/resources/icons/property-styles/icon-agricultural.svg?url';
import houses from '@propertypal/shared/src/resources/icons/property-styles/icon-allHouses.svg?url';
import apartments from '@propertypal/shared/src/resources/icons/property-styles/icon-apartments.svg?url';
import bungalow from '@propertypal/shared/src/resources/icons/property-styles/icon-bungalows.svg?url';
import commercialLand from '@propertypal/shared/src/resources/icons/property-styles/icon-commercialLand.svg?url';
import detached from '@propertypal/shared/src/resources/icons/property-styles/icon-detached.svg?url';
import farmBungalow from '@propertypal/shared/src/resources/icons/property-styles/icon-farmhouseBungalow.svg?url';
import farmDetached from '@propertypal/shared/src/resources/icons/property-styles/icon-farmhouseDetached.svg?url';
import farmSemiDetached from '@propertypal/shared/src/resources/icons/property-styles/icon-farmhouseSemiDetached.svg?url';
import hotels from '@propertypal/shared/src/resources/icons/property-styles/icon-hotels.svg?url';
import defaultIcon from '@propertypal/shared/src/resources/icons/property-styles/icon-housesWithLand.svg?url';
import industrial from '@propertypal/shared/src/resources/icons/property-styles/icon-industrial.svg?url';
import industrialLand from '@propertypal/shared/src/resources/icons/property-styles/icon-industrialLand.svg?url';
import office from '@propertypal/shared/src/resources/icons/property-styles/icon-office.svg?url';
import parking from '@propertypal/shared/src/resources/icons/property-styles/icon-parking.svg?url';
import pubRestaurant from '@propertypal/shared/src/resources/icons/property-styles/icon-pubsAndRestaurants.svg?url';
import residentialLand from '@propertypal/shared/src/resources/icons/property-styles/icon-residentialLand.svg?url';
import retail from '@propertypal/shared/src/resources/icons/property-styles/icon-retail.svg?url';
import roomLet from '@propertypal/shared/src/resources/icons/property-styles/icon-roomLets.svg?url';
import semiDetached from '@propertypal/shared/src/resources/icons/property-styles/icon-semiDetached.svg?url';
import terraced from '@propertypal/shared/src/resources/icons/property-styles/icon-terraced.svg?url';

import { ImgHTMLAttributes } from 'react';

export const PROPERTY_STYLE_ICON_MAP: { [key: string]: ImgHTMLAttributes<any> } = {
  default: defaultIcon,
  auctionsDefault: defaultIcon,
  apartments,
  agriculturalDefault: defaultIcon,
  agriculturalLand,
  bungalow,
  commercial: office,
  commercialDefault: office,
  commercialLand,
  detached,
  farmDetached,
  farmSemiDetached,
  farmBungalow,
  hotelBB: hotels,
  houses,
  IndependentLiving: defaultIcon,
  industrial,
  industrialLand,
  business: office,
  office,
  parking,
  pubRestaurant,
  residentialDefault: defaultIcon,
  residentialLand,
  retail,
  roomLet,
  servicedOffice: office,
  semiDetached,
  studentDefault: defaultIcon,
  terraced,
};

export const getPropertyStyleIcon = (category: string, style: string): ImgHTMLAttributes<any> => {
  let icon = PROPERTY_STYLE_ICON_MAP.default;

  if (PROPERTY_STYLE_ICON_MAP[style]) {
    icon = PROPERTY_STYLE_ICON_MAP[style];
  } else if (PROPERTY_STYLE_ICON_MAP[`${category}Default`]) {
    icon = PROPERTY_STYLE_ICON_MAP[`${category}Default`];
  }

  return icon;
};
